import { render } from "./generalformcta.vue?vue&type=template&id=068e27c2&scoped=true"
import script from "./generalformcta.vue?vue&type=script&lang=js"
export * from "./generalformcta.vue?vue&type=script&lang=js"

import "./generalformcta.vue?vue&type=style&index=0&id=068e27c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-068e27c2"

export default script